/**
 * Stories implemented
 */
/* eslint-disable local-rules/require-storybook-documentation */
import type { FunctionComponent } from 'react';
import { HUMAN_LEGIBLE_DEFAULT_HELP_HOTLINE } from 'src/common/constants';
import { PhoneLink } from 'src/components/Typography/PhoneLink';
import { getPhoneNumber } from 'src/components/Typography/PhoneLink/utils/getPhoneNumber';
import { ErrorPage } from './ErrorPage';

export const UnauthorizedPage: FunctionComponent = () => (
    <ErrorPage
        headingText="You are not authorized to access this page"
        subHeadingText={
            <>
                Please try logging in with a different account or call us at{' '}
                <PhoneLink {...getPhoneNumber(HUMAN_LEGIBLE_DEFAULT_HELP_HOTLINE)} /> with any questions about Zillow
                Home Loans, including updates on your loan application.
            </>
        }
    />
);
